import React, { Component } from 'react';

import Grid from '@material-ui/core/Grid';

import Filters from '../../components/Filters/Filters';
import Boolean from '../../components/Inputs/Boolean/Boolean';

import DependenciaAdministrativaFilter from '../DependenciaAdministrativa/DependenciaAdministrativaFilter';
import EnderecoFilter from '../Endereco/EnderecoFilter';
import EscolaFilter from './EscolaFilterFields';

import { removePagingAndSorting } from '../../helper/PaginationHelper';

export class EscolaPublicoFilter extends Component {
    constructor(props) {
        super(props);
        props.parentRef(this);
        this.state = {
            filters: {
                inscrita: '',
            },
            count: 0,
        }
    }

    // INPUTS
    handleChange = e => {
        this.setState({
            filters: { ...this.state.filters, [e.target.name]: e.target.value }
        });
    };

    // DECLARAÇÃO DE REFERÊNCIA DOS COMPONENTES TIPO FORM
    setEnderecoFilter = form => this.EnderecoFilter = form;
    setDependenciaAdministrativaFilter = form => this.DependenciaAdministrativaFilter = form;
    setEscolaFilter = form => this.EscolaFilter = form;

    // APLICAR PERSISTENCIA
    handleFilterPersistence = (filters) => {
        filters = removePagingAndSorting(filters);

        this.setState({
            filters: {
                inscrita: filters.find(f => f.field === 'inscrita') ? filters.find(f => f.field === 'inscrita').value : "",
            },
            count: filters.reduce((total, f) => f.value !== '' ? total + 1 : total, 0),
        })

        this.EscolaFilter.setState({
            filters: {
                inepSchool: filters.find(f => f.field === 'cdEscola') ? filters.find(f => f.field === 'cdEscola').value : "",
            }
        })

        this.DependenciaAdministrativaFilter.setState({
            filters: {
                adminDep: filters.find(f => f.field === 'nmDependenciaAdministrativa') ? filters.find(f => f.field === 'nmDependenciaAdministrativa').value : "",
            }
        })

        this.EnderecoFilter.setState({
            filters: {
                UF: filters.find(f => f.field === 'cdUf') ? filters.find(f => f.field === 'cdUf').value : "",
                city: filters.find(f => f.field === 'cdMunicipio') ? filters.find(f => f.field === 'cdMunicipio').value : "",
                region: filters.find(f => f.field === 'cdRegiao') ? filters.find(f => f.field === 'cdRegiao').value : "",
            }
        })
    }

    // FILTROS
    handleFilterApply = () => {
        const f = [];
        const { filters } = this.state;
        const filtersDepAdmin = this.DependenciaAdministrativaFilter.state.filters;
        const filtersEscola = this.EscolaFilter.state.filters;
        const filtersEndereco = this.EnderecoFilter.state.filters;

        if (filters.inscrita !== '') f.push({ field: 'inscrita', value: filters.inscrita })

        if (filtersDepAdmin.adminDep) f.push({ field: 'nmDependenciaAdministrativa', value: filtersDepAdmin.adminDep })

        if (filtersEscola.inepSchool) f.push({ field: 'cdEscola', value: filtersEscola.inepSchool })

        if (filtersEndereco.UF) f.push({ field: 'cdUf', value: filtersEndereco.UF })
        if (filtersEndereco.city) f.push({ field: 'cdMunicipio', value: filtersEndereco.city })
        if (filtersEndereco.region) f.push({ field: 'cdRegiao', value: filtersEndereco.region })

        this.props.handleFilterChange(f);
    }

    // LIMPAR FILTROS
    handleFilterClear = () => {
        this.setState({
            filters: {
                inscrita: '',
            },
            count: 0,
        })

        this.DependenciaAdministrativaFilter.setState({
            filters: {
                adminDep: '',
            }
        })

        this.EscolaFilter.setState({
            filters: {
                inepSchool: '',
            }
        })

        this.EnderecoFilter.setState({
            filters: {
                city: '',
                UF: '',
                region: '',
            }
        })

        this.props.handleFilterChange([], false);
    }

    // CONTAGEM DE FILTROS ATIVOS
    handleCountFilters = () => this.state.count;

    render() {
        return (
            <Filters
                handleFilter={this.handleFilterApply}
                handleFilterClear={this.handleFilterClear}
                countFilters={this.handleCountFilters}
                openForever={true}
            >
                <Grid item container spacing={3}>
                    <EscolaFilter
                        parentRef={this.setEscolaFilter}
                        disabledEmail={true}
                        disabledNameSchool={true}
                    />
                    <DependenciaAdministrativaFilter
                        parentRef={this.setDependenciaAdministrativaFilter}
                        withFederal={true}
                    />
                    <EnderecoFilter
                        parentRef={this.setEnderecoFilter}
                        withRegion={true}
                    />
                    <Grid item sm={12} lg={2}>
                        <Boolean
                            label="Inscrita"
                            name='inscrita'
                            value={this.state.filters.inscrita}
                            onChange={(e) => this.handleChange(e)}
                        />
                    </Grid>
                </Grid>
            </Filters>
        )
    }
}

export default EscolaPublicoFilter;